import { TesInteligenteService } from './../../../service/tes-inteligente.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDialogService, PoDynamicFormField, PoLookupColumn, PoModalComponent, PoNotificationService, PoPageAction, PoSelectOption, PoTableColumn } from '@po-ui/ng-components';
import { Cliente } from 'src/app/interface/cliente';
import { CondicaoPagamento } from 'src/app/interface/condicao-pagamento';
import { EstimativaNegociacao } from 'src/app/interface/estimativa-negociacao';
import { Formula } from 'src/app/interface/formula';
import { Produto } from 'src/app/interface/produto';
import { Transportadora } from 'src/app/interface/transportadora';
import { Zpr } from 'src/app/interface/zpr';
import { CondicaoPagamentoLookupService } from 'src/app/service/condicao-pagamento-lookup-service';
import { EstimativaNegociacaoLookupService } from 'src/app/service/estimativa-negociacao-lookup-service';
import { FormulaService } from 'src/app/service/formula-service';
import { Tes, TesLookupService } from 'src/app/service/tes-service';
import { TransportadoraService } from 'src/app/service/transportadora-service';
import { UtilService } from 'src/app/service/util';
import { ZprLookupService } from 'src/app/service/zpr-lookup.service';
import { getPedidoDefault, getPedidoItemDefault, PedidoDto, PedidoItemDto } from '../../interface/pedido';
import { PedidoService } from '../../service/pedido.service';
import { ClienteLookupService } from 'src/app/service/cliente-lookup-service';
import { Fornecedor } from 'src/app/interface/fornecedor';
import { FornecedorLookupService } from 'src/app/service/fornecedor-lookup-service';
import { ProdutoLookupService } from 'src/app/service/produto-lookup-service';
import { environment } from 'src/environments/environment';
import { BaseService } from 'src/app/service/base-service';
import { BaseSX5 } from 'src/app/interface/base';

@Component({
  selector: 'app-pedido-venda-cadastro',
  templateUrl: './pedido-venda-cadastro.component.html',
  styleUrls: ['./pedido-venda-cadastro.component.css']
})
export class PedidoVendaCadastroComponent implements OnInit {

  pedido: PedidoDto;
  itens: Array<PedidoItemDto>;
  itemPedido: PedidoItemDto;

  guaritaAdvancedFilters: Array<PoDynamicFormField>;
  guaritaColumnsFilters: Array<PoLookupColumn>;
  guaritaFieldFormaterFilters: (value: Zpr) => string;

  advancedClienteFilters: Array<PoDynamicFormField>;
  columnsClienteFilters: Array<PoLookupColumn>;
  fieldFormaterClienteFilters: ((value: Cliente) => string);

  advancedFornecedorFilters: Array<PoDynamicFormField>;
  columnsFornecedorFilters: Array<PoLookupColumn>;
  fieldFormaterFornecedorFilters: ((value: Fornecedor) => string);

  advancedProdutoFilters: Array<PoDynamicFormField>;
  columnsProdutoFilters: Array<PoLookupColumn>;
  fieldFormaterProdutoFilters: ((value: Produto) => string);

  advancedCondicaoPagamentoFilters: Array<PoDynamicFormField>;
  columnsCondicaoPagamentoFilters: Array<PoLookupColumn>;
  fieldFormaterCondicaoPagamentoFilters: ((value: CondicaoPagamento) => string);

  advancedTesFilters: Array<PoDynamicFormField>;
  columnsTesFilters: Array<PoLookupColumn>;
  fieldFormaterTesFilters: ((value: Tes) => string);

  advancedTransportadoraFilters: Array<PoDynamicFormField>;
  columnsTransportadoraFilters: Array<PoLookupColumn>;
  fieldFormaterTransportadoraFilters: ((value: Transportadora) => string);

  advancedEstimativaNegociacaoFilters: Array<PoDynamicFormField>;
  columnsEstimativaNegociacaoFilters: Array<PoLookupColumn>;
  fieldFormaterEstimativaNegociacaoFilters: ((value: EstimativaNegociacao) => string);

  advancedFormulaFilters: Array<PoDynamicFormField>;
  columnsFormulaFilters: Array<PoLookupColumn>;
  fieldFormaterFormulaFilters: ((value: Formula) => string);

  varTipoPedido: Array<PoSelectOption>;
  varTipoCliente: Array<PoSelectOption>;
  varTipoFrete: Array<PoSelectOption>;
  varPedidoComplementar: Array<PoSelectOption>;

  podeSalvar: boolean = false;
  disableSalvar: boolean = true;

  acao: string = "Criação";
  acaoTela: string = " - Cadastro";

  formatExtended: PoDatepickerIsoFormat;

  urlApiProtheus: string = environment.urlApiProtheus;

  constructor(
    private router: Router,
    private pedidoService: PedidoService,
    private poDialogService: PoDialogService,
    private poNotificationService: PoNotificationService,
    private route: ActivatedRoute,
    private utilService: UtilService,
    private tesInteligenteService: TesInteligenteService,
    public zprLookupService: ZprLookupService,
    public clienteLookupService: ClienteLookupService,
    public fornecedorLookupService: FornecedorLookupService,
    public produtoLookupService: ProdutoLookupService,
    public condicaoPagamentoLookupService: CondicaoPagamentoLookupService,
    public tesLookupService: TesLookupService,
    public transportadoraService: TransportadoraService,
    public estimativaNegociacaoLookupService: EstimativaNegociacaoLookupService,
    public formulaService: FormulaService,
    public baseService: BaseService,
  ) {
    this.pedido = getPedidoDefault();
    this.itens = [];
    this.itemPedido = getPedidoItemDefault();

    this.zprLookupService.grupo      = 'GUARITA';
    this.guaritaAdvancedFilters      = this.zprLookupService.getAdvancedFilter();
    this.guaritaColumnsFilters       = this.zprLookupService.getColumnsFilter();
    this.guaritaFieldFormaterFilters = this.zprLookupService.getFieldFormater;

    this.advancedClienteFilters = this.clienteLookupService.getAdvancedFilter();
    this.columnsClienteFilters = this.clienteLookupService.getColumnsFilter();
    this.fieldFormaterClienteFilters = this.clienteLookupService.getFieldFormater;

    this.advancedFornecedorFilters = this.fornecedorLookupService.getAdvancedFilter();
    this.columnsFornecedorFilters = this.fornecedorLookupService.getColumnsFilter();
    this.fieldFormaterFornecedorFilters = this.fornecedorLookupService.getFieldFormater;

    this.advancedProdutoFilters = this.produtoLookupService.getAdvancedFilter();
    this.columnsProdutoFilters = this.produtoLookupService.getColumnsFilter();
    this.fieldFormaterProdutoFilters = this.produtoLookupService.getFieldFormater;

    this.advancedCondicaoPagamentoFilters = this.condicaoPagamentoLookupService.getAdvancedFilter();
    this.columnsCondicaoPagamentoFilters = this.condicaoPagamentoLookupService.getColumnsFilter();
    this.fieldFormaterCondicaoPagamentoFilters = this.condicaoPagamentoLookupService.getFieldFormater;

    this.advancedTesFilters = this.tesLookupService.getAdvancedFilter();
    this.columnsTesFilters = this.tesLookupService.getColumnsFilter();
    this.fieldFormaterTesFilters = this.tesLookupService.getFieldFormater;

    this.advancedTransportadoraFilters = this.transportadoraService.getAdvancedFilter();
    this.columnsTransportadoraFilters = this.transportadoraService.getColumnsFilter();
    this.fieldFormaterTransportadoraFilters = this.transportadoraService.getFieldFormater;

    this.advancedEstimativaNegociacaoFilters = this.estimativaNegociacaoLookupService.getAdvancedFilter();
    this.columnsEstimativaNegociacaoFilters = this.estimativaNegociacaoLookupService.getColumnsFilter();
    this.fieldFormaterEstimativaNegociacaoFilters = this.estimativaNegociacaoLookupService.getFieldFormater;

    this.advancedFormulaFilters = this.formulaService.getAdvancedFilter();
    this.columnsFormulaFilters = this.formulaService.getColumnsFilter();
    this.fieldFormaterFormulaFilters = this.formulaService.getFieldFormater;

    this.varTipoPedido = this.listaTipoPedido();
    this.varTipoCliente = this.listaTipoCliente();
    this.varTipoFrete = this.listaTipoFrete();
    this.varPedidoComplementar = this.listaPedidoComplementar();

    this.formatExtended = PoDatepickerIsoFormat.Extended;
  }

  @ViewChild('itemModal', { static: true }) itemModal!: PoModalComponent;
  @ViewChild('formPedido', { static: true }) formPedido!: NgForm;
  @ViewChild('formItem', { static: true }) formItem!: NgForm;

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if ('CC5NUM' in params) {
        this.pedidoService.getPedido(params['CC5NUM']).subscribe((ret) => {
          this.pedido = ret;

          if (params['ACAO'] == 'copiar') {
            this.pedido.CC5NUM = '';
            this.pedido.CC5LIBEROK = '';
            this.pedido.CC5NOTA = '';
            this.pedido.CC5BLQ = '';
            this.pedido.NREGSC5 = 0;

            this.pedido.items.forEach((item) => {
              item.NC6QTDENT = 0;
              item.NC6QTDLIB = 0;
              item.NC6QTDLIB2 = 0;
              item.NC6QTDENT2 = 0;
            })

          } else {
            this.acaoTela = this.pedido.CC5NUM + " - Alterar"
          }

          if (!this.pedido.CC5LIBEROK && !this.pedido.CC5NOTA) {
            this.podeSalvar = true;
            this.disableSalvar = false;
            this.pedido.items = this.pedido.items.map((item) => {
              return {...item, favorite: ['edit', 'delete']}
            });
          } else {
            this.acaoTela = this.pedido.CC5NUM + " - Visualizar"
          }

          this.itens = this.pedido.items.map((item: PedidoItemDto)=> {
            if(params['ACAO'] == 'copiar'){
              return {...item, CC6OPER: '', CC6TES: '' };
            } else {
              return {...item};
            }
          });
        });
      } else {
        this.podeSalvar = true;
        this.disableSalvar = false;
      }
    })
  }

  public readonly colunas: Array<PoTableColumn> = [
    {property: 'CC6ITEM'      , label: 'Item'           , width: '5%'  },
    {property: 'CC6PRODUTO'   , label: 'Produto'        , width: '10%' },
    {property: 'CC6DESCRI'    , label: 'Descrição'      , width: '35%' },
    {property: 'CC6UM'        , label: 'UM'             , width: '5%'  },
    {property: 'NC6QTDVEN'    , label: 'Quantidade'     , type: 'number', format: '1.3-3' },
    {property: 'NC6PRCVEN'    , label: 'Preço Unitário' , type: 'number', format: '1.5-5' },
    {property: 'NC6VALOR'     , label: 'Total'          , type: 'number', format: '1.2-2' },
    {property: 'NC6QTDENT'    , label: 'Qtd Entregue'   , type: 'number', format: '1.3-3' },
    {property: 'CZACPROJET'   , label: 'Projetos'       , width: '10%'        },
    {property: 'favorite'     , label: '...'            , width: '10%', type: 'icon',
      icons: [
        {
          action: this.edit.bind(this),
          icon: 'po-icon-edit',
          tooltip: 'Editar',
          value: 'edit',
        },
        {
          action: this.modalDeletarItemPedido.bind(this),
          icon: 'po-icon-delete',
          tooltip: 'Deletar',
          value: 'delete',
        },
      ]
    }
  ];

  public readonly actions: Array<PoPageAction> = [
    { label: 'Salvar', action: this.modalSalvarPedidoVenda.bind(this), disabled: this.formPedidoValidar.bind(this)},
    { label: 'Duplicar', action: this.modalDuplicarPedidoVenda.bind(this), disabled: this.disableDuplicar.bind(this)},
    { label: 'Sair', action: this.goHome.bind(this)},
  ];

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Pedido de Venda', action: this.goHome.bind(this) },
      { label: 'Cadastro' }
    ]
  };

  goHome(): void {
    this.router.navigateByUrl('/faturamento/pedido-venda/lista');
  }

  modalSalvarPedidoVenda(): void {
    this.poDialogService.confirm({
      title: 'Salvar Pedido de Venda',
      message: 'Deseja realmente salvar o Pedido de Venda?',
      confirm: () => this.salvarPedidoVenda()
    });
  }

  salvarPedidoVenda(): void {
    const valid = this.itens.find((item)=> !(item.CC6OPER))

    if(valid) {
      return  this.poNotificationService.error(`Informe o tipo de operação do Produto ${valid.CC6PRODUTO}`);
    }

    this.pedido.items = this.itens;
    this.pedidoService.postPedido(this.pedido).subscribe((ret) => {
      this.poNotificationService.success(`Pedido ${ret.CC5NUM} incluído com sucesso.`);
      this.router.navigateByUrl('/faturamento/pedido-venda/lista');
    });
  }

  listaTipoPedido(): Array<PoSelectOption> {
    return [
      { value: "N", label: "Normal"                 },
      { value: "B", label: "Utiliza Fornecedor"     },
    ];
  }

  listaTipoCliente(): Array<PoSelectOption> {
    return [
      { value: "F", label: "Consumidor Final"       },
      { value: "L", label: "Produtor Rural"         },
      { value: "R", label: "Revendedor"             },
      { value: "S", label: "Solidário"              },
      { value: "X", label: "Exportação/Importação"  },
    ];
  }

  listaTipoFrete(): Array<PoSelectOption> {
    return [
      { value: "C", label: "CIF"                    },
      { value: "F", label: "FOB"                    },
    ];
  }

  listaPedidoComplementar(): Array<PoSelectOption> {
    return [
      { value: "N", label: "Não"                    },
      { value: "S", label: "Sim"                    },
    ];
  }

  clienteSelecionado(row: Cliente): void {
    this.pedido.CC5CLIENTE = row.CA1COD;
    this.pedido.CC5LOJACLI = row.CA1LOJA;
  }

  fornecedorSelecionado(row: Fornecedor): void {
    this.pedido.CC5CLIENTE = row.CA2COD;
    this.pedido.CC5LOJACLI = row.CA2LOJA;
  }

  alteraTipoPedido(): void {
    this.pedido.CC5CLIENTE = '';
    this.pedido.CC5LOJACLI = '';
    this.pedido.CC5CLIENTELOJA = '';
    this.pedido.CC5FORNECEDORLOJA = '';
  }

  produtoSelecionado(row: Produto): void {
    this.itemPedido.CC6DESCRI = row.CB1DESC;
    this.itemPedido.CC6UM = row.CB1UM;
  }

  estimativaNegociacaoSelecionada(row: EstimativaNegociacao): void {
    this.itemPedido.CZACPROJET = row.CZACPROJET;
  }

  btnNovoItem(): void {
    this.itemPedido = getPedidoItemDefault();
    this.acao = "Criação";
    this.itemModal.open();
  }

  modalDuplicarPedidoVenda(): void {
    this.poDialogService.confirm({
      title: 'Duplicar Pedido de Venda',
      message: 'Deseja realmente duplicar o Pedido de Venda?',
      confirm: () => this.btnDuplicarPedido()
    });
  }

  btnDuplicarPedido(): void {
    this.router.navigateByUrl(`/faturamento/pedido-venda/cadastro/copiar/${this.pedido.CC5NUM}`);
  }

  salvarItemPedido(): void {
  let erro = false;
  let isNovo = false;
  if (!this.itemPedido.uuid && !this.itemPedido.CC6ITEM) {
    isNovo = true;
    this.itemPedido.uuid = this.utilService.getUniqueId(4);
  }
  this.itemPedido.NC6VALOR = this.itemPedido.NC6PRCVEN * this.itemPedido.NC6QTDVEN;
  if (isNovo) {
    this.itens.push(this.itemPedido);
  } else {
    let index = -1;
    if (this.itemPedido.CC6ITEM) {
      index = this.itens.findIndex(item => item.CC6ITEM === this.itemPedido.CC6ITEM);
    } else {
      index = this.itens.findIndex(item => item.uuid === this.itemPedido.uuid);
    }
    if (index >= 0) {

      if (this.itens[index].NC6QTDENT > 0) {
        if (this.itens[index].CC6PRODUTO !== this.itemPedido.CC6PRODUTO) {
          erro = true;
          this.poNotificationService.error('Não é possível alterar o produto, pois já possui quantidade entregue.');
        } else if (this.itemPedido.NC6QTDVEN < this.itemPedido.NC6QTDENT) {
          erro = true;
          this.poNotificationService.error(`Alteração inválida. Quantidade de venda menor que a quantidade entregue (${this.itemPedido.NC6QTDENT})`);
        }
      }
      if (!erro) {
        this.itens[index] = this.itemPedido;
      }
    }
  }
  if (!erro) {
    this.itemPedido = getPedidoItemDefault();
    this.itemModal.close();
  }
}


  formItemValidar(): boolean {
    return !(this.formItem.valid);
  }

  formPedidoValidar(): boolean {
    if (this.formPedido.valid && this.itens.length > 0 && this.podeSalvar) {
      return false;
    }
    return true;
  }

  disableDuplicar(): boolean {
    return this.pedido.CC5NUM == "";
  }

  edit(item: PedidoItemDto): void {
    this.itemPedido = Object.assign({}, item);
    this.acao = "Alteração";
    this.itemModal.open();
  }

  modalDeletarItemPedido(itemPedido: PedidoItemDto): void {
    if (itemPedido.NC6QTDENT == 0) {
      this.poDialogService.confirm({
        title: 'Excluir Item',
        message: 'Deseja realmente excluir esse item do pedido?',
        confirm: () => this.deleteItemPedido(itemPedido)
      });
    } else {
      this.poNotificationService.error(`Não é possível deletar o item, pois já possui quantidade entregue.`);
    }
  }

  deleteItemPedido(itemPedido: PedidoItemDto): void {
    let index = -1;
    if (itemPedido.CC6ITEM) {
      index = this.itens.findIndex(item => item.CC6ITEM === itemPedido.CC6ITEM);
    } else {
      index = this.itens.findIndex(item => item.uuid === itemPedido.uuid);
    }
    if (index >= 0) {
      this.pedido.LUTDELETA = "S";
      this.itens = this.itens.filter((item,id)=> id != index);
    }
  }

  selectTipoOpercao(dados: BaseSX5): void {
    const { CC5CLIENTELOJA, CC5FORNECEDORLOJA } = this.pedido;
    const { CC6PRODUTO } = this.itemPedido;
    const CTIPOPESSOA = (this.pedido.CC5TIPO !== 'B') ? 'C' : 'F';

    this.tesInteligenteService.getTipoOperacao(dados.CX5CHAVE, CC6PRODUTO, CTIPOPESSOA, (CC5CLIENTELOJA || CC5FORNECEDORLOJA)).subscribe(
      (ret)=> {
        this.itemPedido.CC6TES = ret.CFMTS;
      },
      (err)=> {
        this.itemPedido.CC6TES = '';
      }
    );
  }

}
